import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const LocationService = {
  listLocations: async ({ loadAll = true, page = 1, pageSize = 10 }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.LOCATION.LIST, {
      loadAll,
      page,
      pageSize,
    });
    const response = await api.get(endpoint);
    return response;
  },
};
